<script setup lang="ts">
const carousels = [
  {
    title: 'Laporkan Masalah',
    description: 'Pilih paket bermasalah dan isi laporan klaim.'
  },
  {
    title: 'Validasi Otomatis',
    description: 'Sistem langsung cek data pengiriman & status.'
  },
  {
    title: 'Tinjauan Tim KiriminAja',
    description: 'Kami koordinasi dengan ekspedisi hingga tuntas.'
  },
  {
    title: 'Dana Cair ke Akun Member',
    description: 'Tanpa tunggu lama, semua proses transparan.'
  }
]
</script>

<template>
  <div
    class="bg-surface-container-low dark:bg-surface-container-highest py-6 lg:py-16 relative overflow-hidden"
  >
    <UiBgSkewY />
    <UiContainer class="flex flex-col gap-6 lg:gap-11 relative z-10">
      <UiSectionTitle
        class="lg:text-center"
        title="Semua Langkah Klaim, Terpadu dalam Satu Dashboard KiriminAja"
        description="Satu dashboard untuk semua kendala pengiriman — dari notifikasi sampai tindakan langsung."
      />
      <UiCarouselFeature
        :items="carousels"
        hide-nav-button
        class-content-wrapper="overflow-visible"
      />
    </UiContainer>
  </div>
</template>
